import React from 'react';
import { Button, Tooltip } from 'antd';
import { ArrowDown } from 'lucide-react';
import preserveInputFocus from '../../composer/preserveInputFocus.js';

export default function LatestMessageButton({ label, onReadLatest, themeTokens }) {
  const resolvedLabel = String(label || '查看最新');
  return (
    <Tooltip placement="top" title={resolvedLabel}>
      <Button
        aria-label={resolvedLabel}
        icon={<ArrowDown aria-hidden="true" size={19} strokeWidth={2} />}
        onClick={onReadLatest}
        onMouseDown={preserveInputFocus}
        shape="circle"
        size="large"
        style={{
          background: themeTokens.bubbleUserBg,
          border: `1px solid ${themeTokens.bubbleUserBorder || themeTokens.divider}`,
          boxShadow: '0 8px 24px rgba(47, 111, 236, 0.22)',
          color: '#fff',
        }}
        type="default"
      />
    </Tooltip>
  );
}
